import createVueComponent from '../createVueComponent';

const MoveUp = createVueComponent('MoveUpIcon', [
  ['path', { d: 'M8 6L12 2L16 6', key: '1yvkyx' }],
  ['path', { d: 'M12 2V22', key: 'r89rzk' }],
]);

export default MoveUp;
